var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.48571 20 0 15.5142 0 10C0 4.48582 4.48582 0 10 0C15.5142 0 20 4.48582 20 10C20 15.5142 15.5142 20 10 20ZM10 1.71429C5.4 1.71429 1.68571 5.42842 1.68571 10C1.68571 14.5716 5.40005 18.3143 10 18.3143C14.5999 18.3143 18.3143 14.5999 18.3143 10C18.2856 5.42847 14.5715 1.71429 10 1.71429Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74288 12.7714C9.28569 12.7714 8.88569 12.3999 8.88569 11.9142C8.88569 10.5999 9.74288 9.4571 10.9713 9.08562C11.5143 8.91422 11.8857 8.42853 11.857 7.85715C11.857 6.82858 10.9998 5.97138 9.97125 5.97138C8.94268 5.97138 8.08548 6.82858 8.08548 7.85715C8.08548 8.31434 7.71399 8.71434 7.22829 8.71434C6.7711 8.71434 6.37109 8.34285 6.37109 7.85715C6.42849 5.88567 8.02844 4.28572 9.99992 4.28572C11.9714 4.28572 13.5713 5.88567 13.5713 7.85715C13.5713 9.17154 12.7142 10.3143 11.4857 10.6858C10.9428 10.8572 10.5713 11.3429 10.6 11.9142C10.6 12.3714 10.2001 12.7714 9.74288 12.7714Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.771 14.5429C10.771 15.1111 10.3104 15.5714 9.74244 15.5714C9.17422 15.5714 8.71387 15.1111 8.71387 14.5429C8.71387 13.9749 9.17424 13.5143 9.74244 13.5143C10.3104 13.5143 10.771 13.9749 10.771 14.5429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7);
export default __webpack_public_path__ + "static/media/Group-7.39806eb30e7900df14fd1dbc455e8f4d.svg";
export { ForwardRef as ReactComponent };